import clsx from 'clsx'
import { useState } from 'react'

import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Icon } from '@/shared/ui/icon'

import cls from './discount-list.module.scss'

type DiscountListProps = {
	items: { NAME: string; AMOUNT: number }[]
	price: number
	defaultOpen?: boolean
	className?: string
}

export const DiscountList = (props: DiscountListProps) => {
	const { items, price, defaultOpen = false, className } = props

	const [isOpen, setOpen] = useState(defaultOpen)

	return (
		<div className={className}>
			<div className={cls.topPanel} onClick={() => setOpen(!isOpen)}>
				<p>
					Выгода <Icon size={16} name={isOpen ? 'ArrowUp' : 'ArrowDown'} />
				</p>
				<p>{formatPrice(price)}</p>
			</div>
			<div className={clsx(cls.inner, isOpen && cls.inner__open)}>
				<div className={cls.list}>
					{items.map(({ NAME, AMOUNT }) => (
						<div key={NAME} className={cls.item}>
							<p>{NAME}</p>
							<p>{formatPrice(AMOUNT)}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
